import { BadgeVariant } from '@tablecheck/tablekit-react';

import { AppNoticeCategory } from 'components/appNotices/types';

export function getBadgeVariantForAppNotice(
  category: AppNoticeCategory
): BadgeVariant {
  switch (category) {
    case 'event':
      return 'info';
    case 'incident':
      return 'error';
    case 'release':
      return 'success';
    case 'maintenance':
      return 'warning';
    case 'campaign':
      return 'purple';
    case 'billing':
      return 'orange';
    default:
      return 'neutral';
  }
}

export const getFormattedDate = (
  publishedDate: string,
  locale: string
): string => {
  try {
    return new Date(publishedDate).toLocaleDateString(locale, {
      month: '2-digit',
      year: 'numeric',
      day: '2-digit'
    });
  } catch (e) {
    const date = new Date(publishedDate);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}/${month}/${day}`;
  }
};
